module.exports = __webpack_public_path__ + "img/1752629769892-19708390-2d67-47c1-b6db-77acb1609701.jpeg.c8706ed5.webp";